import { createFileRoute } from '@tanstack/react-router'
import { Form781A } from 'pages/kestrelForms/aerospace/afto781A/Form781A'
import { z } from 'zod'

const parseParams = z.object({
  inspectionType: z.string(),
  formName: z.string(),
})

const searchSchema = z.object({
  kestrelRolodexEntry: z.string().optional(),
  selectedFormId: z.string().optional(),
})

export const Route = createFileRoute(
  '/kestrel/forms/$inspectionType/$formName'
)({
  component: RouteComponent,
  params: {
    parse: parseParams.parse,
  },
  validateSearch: searchSchema,
  staticData: {
    title: 'Form',
  },
})

function RouteComponent() {
  const { inspectionType, formName } = Route.useParams()
  const { kestrelRolodexEntry, selectedFormId } = Route.useSearch()

  const FormComponent = getFormComponent(inspectionType, formName)

  if (!FormComponent) {
    return (
      <div>
        <h1>Form Not Found</h1>
        <p>
          No form found for {inspectionType.toUpperCase()} -{' '}
          {formName.toUpperCase()}
        </p>
      </div>
    )
  }

  return (
    <FormComponent
      kestrelRolodexEntry={kestrelRolodexEntry}
      initialSelectedFormId={selectedFormId}
    />
  )
}

function getFormComponent(
  inspectionType: string,
  formName: string
): React.FC<{
  kestrelRolodexEntry?: string
  initialSelectedFormId?: string
}> | null {
  const key = `${inspectionType.toLowerCase()}-${formName.toLowerCase()}`

  switch (key) {
    case 'aerospace-781a':
      return Form781A
    default:
      return null
  }
}
